export default {
    Acme: 'Acme',
    AmaticSC: 'AmaticSC',
    ArchitectsDaughter: 'ArchitectsDaughter',
    Arial: 'Arial',
    BlackOpsOne: 'BlackOpsOne',
    Caveat: 'Caveat',
    ChelseaMarket: 'ChelseaMarket',
    ChauPhilomeneOne: 'ChauPhilomeneOne',
    Cinzel: 'Cinzel',
    Curvise: 'curvise',
    DancingScript: 'DancingScript',
    GloriaHallelujah: 'GloriaHallelujah',
    HomemadeApple: 'HomemadeApple',
    LobsterTwo: 'LobsterTwo',
    Monoton: 'Monoton',
    Montaga: 'Montaga',
    Orbitron: 'Orbitron',
    Pacifico: 'Pacifico',
    PatrickHand: 'PatrickHand',
    PermanentMarker: 'PermanentMarker',
    Piedra: 'Piedra',
    PoiretOne: 'PoiretOne',
    PressStart2P: 'PressStart2P',
    RobotoMono: "RobotoMono",
    RockSalt: "RockSalt",
    Sacramento: "Sacramento",
    Satisfy: "Satisfy",
    ShadowsIntoLight: "ShadowsIntoLight",
    Tangerine: "Tangerine",
    TangeTenaliRamakrishnarine: "TenaliRamakrishna",
    TimesRoman: 'Times Roman'
}